var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPayBillIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 26.5,
    cy: 26.5,
    r: 26.5,
    fill: "#535C64"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.9071 29.7088L36.1021 32.0048V36.0673H15.9172V38H36.1021C36.3509 38.0015 36.5975 37.9537 36.8278 37.8593C37.058 37.7649 37.2672 37.6258 37.4434 37.45C37.6195 37.2742 37.7591 37.0653 37.8539 36.8352C37.9488 36.6052 37.9971 36.3586 37.996 36.1098V29.5928L37.9071 29.7088ZM36.1059 14H15.8902C15.6418 13.9995 15.3958 14.0481 15.1662 14.1429C14.9367 14.2377 14.7281 14.3769 14.5525 14.5525C14.3769 14.7281 14.2376 14.9367 14.1428 15.1663C14.048 15.3958 13.9995 15.6418 14 15.8902V36.075H15.9327L15.9018 15.9211H36.0905V20.4861V20.9113L36.1214 20.8726L36.2528 20.7026L37.7603 18.7699L37.2617 22.2757L36.9718 24.3012H38.0038V15.8902C38.0043 15.6412 37.9555 15.3945 37.8602 15.1645C37.7649 14.9344 37.625 14.7255 37.4486 14.5498C37.2722 14.3741 37.0627 14.235 36.8322 14.1406C36.6018 14.0463 36.3549 13.9985 36.1059 14Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5923 25.685L36.3532 29.8132L34.6486 31.9816L33.3189 33.6785L34.1499 28.5647H30.0217L34.6408 22.6468L36.1367 20.7296L35.4294 25.685H39.5923Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5568 17.3591H17.9967V19.2802H28.5568V17.3591Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5568 21.1973H17.9967V23.1184H28.5568V21.1973Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5568 28.8778H17.9967V30.7989H28.5568V28.8778Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5568 32.7199H17.9967V34.641H28.5568V32.7199Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5568 25.0394H17.9967V26.9605H28.5568V25.0394Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayBillIcon);
export default __webpack_public_path__ + "static/media/pay-bill-icon.65258d5fb9449b3599b868cb165720f7.svg";
export { ForwardRef as ReactComponent };